export const ROUTE_PREFIX = '/app';

export const ROUTE = {
  ROOT: ROUTE_PREFIX,
  LEGAL: `${ROUTE_PREFIX}/legal`,
  LEGAL_COMMERCIAL_DEPOSIT_ACCOUNT_AGREEMENT: `${ROUTE_PREFIX}/legal/commercial-deposit-account-agreement`,
  LEGAL_SWEEP_AGREEMENT: `${ROUTE_PREFIX}/legal/column-sweep-program-deposit-placement-custodial-agreements`,
  ENTITIES: `${ROUTE_PREFIX}/entities`,
  ENTITIES_ROOT_ENTITY: `${ROUTE_PREFIX}/entities/root-entity`,
  ENTITIES_ROOT_ENTITY_SANDBOX: `${ROUTE_PREFIX}/entities/root-entity/sandbox`,
  ENTITIES_ROOT_ENTITY_LIVE: `${ROUTE_PREFIX}/entities/root-entity/live`,
  ENTITIES_ROOT_ENTITY_SANDBOX_ACCOUNTS: `${ROUTE_PREFIX}/entities/root-entity/sandbox/accounts`,
  ENTITIES_ROOT_ENTITY_LIVE_ACCOUNTS: `${ROUTE_PREFIX}/entities/root-entity/live/accounts`,
  BANK_ACCOUNTS: `${ROUTE_PREFIX}/accounts`,
  BANK_ACCOUNTS_INTEREST_PAYOUT: `${ROUTE_PREFIX}/accounts/interest-payouts/:id`,
  TRANSFERS: `${ROUTE_PREFIX}/transfers`,
  TRANSFER_APPROVALS: `${ROUTE_PREFIX}/transfers/approvals`,
  TRANSFER_BATCHES: `${ROUTE_PREFIX}/transfers/batches`,
  RETURNS: `${ROUTE_PREFIX}/transfers/returns`,
  COUNTERPARTIES: `${ROUTE_PREFIX}/accounts/counterparties`,
  EVENTS: `${ROUTE_PREFIX}/events`,
  EVENTS_WEBHOOK: `${ROUTE_PREFIX}/events/webhook`,
  PROFILE: `${ROUTE_PREFIX}/profile`,
  PROFILE_NOTIFICATIONS: `${ROUTE_PREFIX}/profile/notifications`,
  DOCUMENTS: `${ROUTE_PREFIX}/documents`,
  REPORTING: `${ROUTE_PREFIX}/documents/reporting`,
  STATEMENTS: `${ROUTE_PREFIX}/documents/statements`,
  LOANS: `${ROUTE_PREFIX}/loans`,
  CONTACT_FORM: `${ROUTE_PREFIX}/contact`,

  PLATFORM_ROOT: `${ROUTE_PREFIX}/platform`,
  PLATFORM: `${ROUTE_PREFIX}/platform/info`,
  PLATFORM_FEATURES: `${ROUTE_PREFIX}/platform/features`,
  PLATFORM_API_KEYS: `${ROUTE_PREFIX}/platform/api-keys`,
  PLATFORM_WEBHOOKS: `${ROUTE_PREFIX}/platform/webhooks`,
  PLATFORM_ROLES: `${ROUTE_PREFIX}/platform/roles`,
  PLATFORM_ROLES_CREATE: `${ROUTE_PREFIX}/platform/roles/create`,
  PLATFORM_SETTINGS: `${ROUTE_PREFIX}/platform/settings`,
  PLATFORM_TEAM: `${ROUTE_PREFIX}/platform/team`,
  PLATFORM_ROOT_ENTITY: `${ROUTE_PREFIX}/platform/root-entity`,

  CARDS: `${ROUTE_PREFIX}/cards`,
  CARD_PROGRAMS: `${ROUTE_PREFIX}/cards/programs`,
  CARD_ACCOUNTS: `${ROUTE_PREFIX}/cards/accounts`,
  CARD_TOKENS: `${ROUTE_PREFIX}/cards/tokens`,
  CARD_TRANSACTIONS: `${ROUTE_PREFIX}/cards/transactions`,
  CARD_DISPUTES: `${ROUTE_PREFIX}/cards/disputes`,
} as const;
